import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CallResourceService, CallStatus, SeekDirection } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxCallService {

  constructor(private callResource: CallResourceService) {
  }

  getCallList(params?: {
    cityIds?: Array<number>;
    countryIds?: Array<number>;
    date?: string;
    limit?: number;
    phone?: string;
    seek?: string;
    seekDir?: SeekDirection;
    statuses?: Array<CallStatus>;
  }) {
    // positional args of the generated client, in its alphabetical order:
    // category, cityIds, counted, countryIds, date, dateFrom, dateTo, dow, dropOff,
    // escalated, followUp, hasFlags, hasOrder, hour, limit, missed, operatorId, phone,
    // recovered, seek, seekDir, sentiment, statuses
    return firstValueFrom(this.callResource.getCallList(
      undefined,
      params?.cityIds,
      undefined,
      params?.countryIds,
      params?.date,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      params?.limit,
      undefined,
      undefined,
      params?.phone,
      undefined,
      params?.seek,
      params?.seekDir,
      undefined,
      params?.statuses,
    ));
  }

  getCallDetailsByCallId(callId: string) {
    return firstValueFrom(this.callResource.getCallDetailsByCallId(callId));
  }

  saveCityIdForCall(callId: string, cityId: number) {
    return firstValueFrom(this.callResource.saveCityIdForCall(callId, cityId));
  }
}
